import '../../style/index.less';
import './index.less';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/alert/style/index.js
// module id = 909
// module chunks = 0